// removed by extract-text-webpack-plugin
module.exports = {"options-list":"MenuOptionsList__options-list___3BZMB"};